import { ListStatementsInput } from '../GlobalTypes'
import { apolloClient } from '../apolloClient'
import { GET_STATEMENT } from './queries/GET_STATEMENT'
import { GetStatement, GetStatementVariables } from '../types/GetStatement'
import { setGlobal } from '../../global/useGlobal'
import { sortInstallmentByDate } from '../../utils/sortInstallmentByDate'

export const getStatement = async (input: ListStatementsInput) => {
  const response = await apolloClient.query<GetStatement, GetStatementVariables>({
    query: GET_STATEMENT,
    variables: { input },
  })

  if (response) {
    const installmentsComing = sortInstallmentByDate(response.data?.listStatements?.installmentsComing)
    setGlobal({
      installmentsComing,
      installmentsOpen: response.data?.listStatements?.installmentsOpen,
      installmentsOverdue: response.data?.listStatements?.installmentsOverdue,
      installmentsPaid: response.data?.listStatements?.installmentsPaid,
      statement: response.data?.listStatements,
    })
  }

  return response.data
}
